// extracted by mini-css-extract-plugin
export var isPrintedCell = "_xf-1";
export var printerIcon = "_xf-0";